<template>
  <ion-tabs>
    <ion-router-outlet></ion-router-outlet>

    <ion-tab-bar slot="bottom" v-if="!isOutsourcing">
      <ion-tab-button tab="timeReport" href="/time-reports">
        <ion-icon :icon="timeOutline"></ion-icon>
        <ion-label>Rapports</ion-label>
      </ion-tab-button>

      <ion-tab-button
        v-if="displayMachineReports"
        tab="machineReport"
        href="/machine-reports"
      >
        <ion-icon :icon="todayOutline"></ion-icon>
        <ion-label>Entretien</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="allRentalCoupon" href="/listeBonLocation">
        <ion-icon :icon="readerOutline"></ion-icon>
        <ion-label>BL / LV</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="planning" href="/planning">
        <ion-img src="/assets/logo/LOCATIERS-ICONE_BLC.png"></ion-img>
        <ion-label>Missions</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="settings" href="/settings">
        <ion-icon :icon="menuOutline"></ion-icon>
        <ion-label>Menu</ion-label>
      </ion-tab-button>
    </ion-tab-bar>

    <ion-tab-bar
      class="outsourcing-bottom-bar"
      slot="top"
      v-if="isOutsourcing && isPwaUser"
    >
      <ion-tab-button tab="backToPlanning" href="/planning">
        <ion-label> ← Retour DriveApp </ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
</template>

<script>
import {
  IonTabs,
  IonTabBar,
  IonRouterOutlet,
  IonTabButton,
  IonIcon,
  IonImg,
  IonLabel,
} from '@ionic/vue';
import {
  readerOutline,
  menuOutline,
  timeOutline,
  todayOutline,
} from 'ionicons/icons';
import { checkIfUser } from '@/services/users';

export default {
  name: 'BottomMenu',
  components: {
    IonTabs,
    IonTabBar,
    IonRouterOutlet,
    IonTabButton,
    IonIcon,
    IonImg,
    IonLabel,
  },
  setup() {
    return {
      readerOutline,
      menuOutline,
      timeOutline,
      todayOutline,
    };
  },

  data() {
    return {
      displayMachineReports: false,
    };
  },

  async mounted() {
    this.displayMachineReports =
      window.localStorage.getItem('displayMachineReports') === 'true';
  },

  computed: {
    isPwaUser() {
      return checkIfUser();
    },

    isOutsourcing() {
      return (
        this.$route && this.$route.params && this.$route.params.outsourcingToken
      );
    },
  },
};
</script>

<style lang="scss" scoped>
ion-img {
  width: 28px;
}

// When outsourcing, simple small bar to go back to "usual" pwa
.outsourcing-bottom-bar {
  --background: #f4f5f8;
  height: 36px;

  ion-label {
    font-weight: bold;
    font-size: 14px;
    color: var(--ion-color-dark);
  }
}
</style>
